import React, { useState } from 'react';
import { Accordion } from './Accordion';
export function Bonos() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const bonos = [{
    num: '01',
    icon: '🗺️',
    title: 'Mapa de las Primeras 100 Señas',
    price: '$8.000',
    desc: 'Las 100 señas más urgentes organizadas por situación real.',
    purpose: 'Para que el día uno no sea abrumador. Tenés un mapa visual que te dice exactamente por dónde empezar según tu situación — familia, trabajo o calle.'
  }, {
    num: '02',
    icon: '✅',
    title: 'Rutina Diaria de 10 Minutos',
    price: '$7.000',
    desc: 'La rutina de 30 días que convierte el aprendizaje en hábito.',
    purpose: 'Para que no dependas de la motivación. Son 10 minutos por día con una estructura clara que hace que avances aunque estés cansado.'
  }, {
    num: '03',
    icon: '💬',
    title: '80 Frases para Situaciones Reales',
    price: '$9.000',
    desc: '80 frases listas para usar desde el primer día.',
    purpose: 'Para que nunca te quedes sin saber qué señar. Cubre calle, salud, trabajo, familia, comercio y emergencias — las situaciones donde más lo necesitás.'
  }, {
    num: '04',
    icon: '📊',
    title: 'Tracker de Avance 30 Días',
    price: '$8.000',
    desc: 'El sistema visual que hace visible tu progreso.',
    purpose: 'Para que nunca dudes de que avanzás. Cada día que completás queda registrado y podés ver tu transformación de semana en semana.'
  }, {
    num: '05',
    icon: '🃏',
    title: 'Flashcards Digitales de Repaso',
    price: '$9.000',
    desc: '200 tarjetas digitales para repasar señas en cualquier momento.',
    purpose: 'Para consolidar lo aprendido en los momentos muertos del día — en el colectivo, esperando turno, en el recreo. Repaso rápido, sin abrir el tomo.'
  }, {
    num: '06',
    icon: '📋',
    title: 'Guía de Expresiones Faciales del LSA',
    price: '$7.000',
    desc: 'La parte que todos ignoran y que define si te entienden o no.',
    purpose: 'La expresión facial en LSA no es opcional — es gramática. Esta guía te muestra exactamente qué cara hacer para cada tipo de oración, pregunta y emoción.'
  }];
  return <section className="bg-lsa-light text-lsa-dark py-16 px-5" data-id="element-26">
      <div className="max-w-xl mx-auto" data-id="element-27">
        <div className="flex justify-center mb-5" data-id="element-28">
          <span className="inline-flex items-center gap-2 bg-green-100 text-green-700 rounded-full px-4 py-1.5 text-xs font-bold tracking-wide" data-id="element-29">
            🎁 Bonos de regalo
          </span>
        </div>

        <h2 className="text-[28px] font-extrabold text-center mb-3 leading-tight" data-id="element-30">
          6 bonos incluidos.{' '}
          <span className="text-green-600" data-id="element-31">Gratis. Siempre.</span>
        </h2>
        <p className="text-center text-lsa-dark/70 text-[16px] font-medium mb-10" data-id="element-32">
          Valor total:{' '}
          <span className="line-through text-lsa-dark/40" data-id="element-33">$48.000 ARS</span> →{' '}
          <span className="font-extrabold text-green-600" data-id="element-34">
            $0 con tu sistema.
          </span>
        </p>

        <div data-id="element-35">
          {bonos.map((bono, index) => <Accordion key={index} theme="light" isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? -1 : index)} title={<div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3" data-id="element-37">
                  <div className="flex items-center gap-2" data-id="element-38">
                    <span className="font-bold text-lsa-celeste text-sm" data-id="element-39">
                      BONO {bono.num}
                    </span>
                    <span className="hidden sm:inline text-lsa-dark/20" data-id="element-40">—</span>
                    <span className="text-xl" data-id="element-41">{bono.icon}</span>
                  </div>
                  <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-4" data-id="element-42">
                    <span className="font-bold" data-id="element-43">{bono.title}</span>
                    <div className="flex items-center gap-2 text-sm" data-id="element-44">
                      <span className="line-through text-lsa-dark/40" data-id="element-45">
                        {bono.price}
                      </span>
                      <span className="bg-green-600 text-white px-2 py-0.5 rounded text-xs font-bold tracking-wide" data-id="element-46">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>} data-id="element-36">
              <div className="pt-2 pb-1" data-id="element-47">
                <p className="font-semibold text-[15px] mb-3 text-lsa-dark" data-id="element-48">
                  {bono.desc}
                </p>
                <div className="bg-lsa-celeste/10 border border-lsa-celeste/20 p-4 rounded-lg" data-id="element-49">
                  <span className="font-bold text-[13px] uppercase tracking-wider text-lsa-celeste block mb-1" data-id="element-50">
                    Para qué sirve:
                  </span>
                  <p className="text-[14px] leading-relaxed text-lsa-dark/80" data-id="element-51">
                    {bono.purpose}
                  </p>
                </div>
              </div>
            </Accordion>)}
        </div>
      </div>
    </section>;
}